// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 MindTenet LLC
// This file is part of Undef Engine.

/**
 * Frontend configuration constants.
 * All default values should be defined here, not inline.
 */

// Vite dev server port (frontend serves through this, proxies API)
export const DEFAULT_SERVER_PORT = 1333;

// API prefix
export const API_PREFIX = '/api';

// Protocol defaults
export const DEFAULT_HTTP_PROTOCOL = 'http';
export const DEFAULT_WS_PROTOCOL = 'ws';

// WebSocket retry configuration
export const WS_MAX_RECONNECT_ATTEMPTS = 10;
export const WS_MAX_AUTH_RETRIES = 2;
export const WS_MAX_SESSION_RETRIES = 3;
export const WS_HEARTBEAT_INTERVAL = 15000; // 15 seconds
export const WS_MAX_MISSED_PONGS = 2;

// Spectator WebSocket configuration
export const SPECTATOR_MAX_RECONNECT_ATTEMPTS = 5;
export const SPECTATOR_INITIAL_CONNECTION_DELAY = 200; // ms
export const SPECTATOR_MAX_INITIAL_RETRIES = 3;

// Player appearance defaults
export const DEFAULT_PLAYER_COLOR = '#a855f7'; // Purple - default for registered users
export const GUEST_PLAYER_COLOR = '#6b7280'; // Gray - for guest/anonymous users
export const DEFAULT_PLAYER_EMOJI = '👤'; // Default emoji for registered users without custom emoji
export const GUEST_PLAYER_EMOJI = '🕵️'; // Anonymous/incognito emoji for guest users
